import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "full-width" }
const _hoisted_2 = { class: "full-width q-mt-xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_editable_block = _resolveComponent("editable-block")!

  return (_openBlock(), _createBlock(_component_editable_block, {
    title: "Business registration details",
    layout: "flex-col",
    "model-value": _ctx.registrationDetails,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:supplier', _ctx.supplier.sys.id, { ..._ctx.registrationDetails, ...$event }))),
    "column-count": 1
  }, {
    default: _withCtx(({ editState }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_editable_block_input, {
          label: "ID",
          modelValue: editState.company_registration.id,
          "onUpdate:modelValue": ($event: any) => ((editState.company_registration.id) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "Registrar",
          modelValue: editState.company_registration.registrar,
          "onUpdate:modelValue": ($event: any) => ((editState.company_registration.registrar) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Tax registration details", -1)),
        _createVNode(_component_editable_block_input, {
          label: "ID",
          modelValue: editState.tax.id,
          "onUpdate:modelValue": ($event: any) => ((editState.tax.id) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "Registrar",
          modelValue: editState.tax.registrar,
          "onUpdate:modelValue": ($event: any) => ((editState.tax.registrar) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}